export let dataProps = {
    id: 0,
    store_id: null, 
    vendor_id: null,
    purchase_bill_id: 0,
    payment_date: new Date(),
    additional_notes: '',
    paid_amount: 0, 
    redeemed_amount: 0,
    advance_payment: false,
    bank_id: null
}


// WEBPACK FOOTER //
// ./src/store/modules/vendorPayment/properties.js